import Divider from '@material-ui/core/Divider';
import InputCheckbox from 'core/modules/atoms/InputCheckbox';
import React from 'react';

function TreeViewSelected({ selected, setSelected }) {
  function getChecked(item) {
    return !!selected.find((element) => element && element.guid === item.guid);
  }

  function onChange(event, item) {
    const checked = event.target.checked;
    const newSelected = checked ? [...selected, item] : selected.filter((element) => element.guid !== item.guid);

    setSelected(newSelected);
  }

  return selected.map((item) => {
    const key = item.guid ? item.guid : item;

    return (
      <div key={key} className="tree-view-selected">
        <div className="tree-view-selected__item">
          <InputCheckbox checked={getChecked(item)} onChange={(event) => onChange(event, item)} label={item.name} subtitle={item.description} />
        </div>

        <Divider />
      </div>
    );
  });
}

export default TreeViewSelected;
